import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger
} from "@/components/ui/dialog.tsx";
import {Button} from "@/components/ui/button.tsx";
import React, {useState} from "react";
import {Trash2} from "lucide-react";
import {notifyError} from "@/api/ErrorNotification.ts";


export default function DeleteConfirm({title, description = "Diese Aktion kann nicht rückgängig gemacht werden.", onConfirm, children}: {
    title: string;
    description?: string;
    onConfirm: () => void | Promise<void>;
    children: React.ReactNode
}) {

    const [open, setOpen] = useState(false);
    const [pending, setPending] = useState(false);

    const handleConfirm = async () => {
        if (pending) return;
        setPending(true);
        try {
            await onConfirm();
            setOpen(false);
        } catch (reason) {
            notifyError(reason, "Der Eintrag konnte nicht gelöscht werden.");
        } finally {
            setPending(false);
        }
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                {children}
            </DialogTrigger>
            <DialogContent className="sm:max-w-106.25 text-center">
                <DialogHeader>
                    <DialogTitle className="text-center">
                        <div
                            className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-destructive/10">
                            <Trash2 className="h-7 w-7 text-destructive"/>
                        </div>
                        {title}
                    </DialogTitle>
                    <DialogDescription className="text-center">
                        {description}
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="mt-2 sm:justify-center">
                    <DialogClose asChild>
                        <Button variant="outline">Abbrechen</Button>
                    </DialogClose>
                    <Button variant="destructive" disabled={pending} onClick={() => void handleConfirm()}>Löschen</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
